// extracted by mini-css-extract-plugin
export default {"bottom-card":"iDE5E","description":"bWoGt","animation-container":"VS8KQ","text":"ACGgH","primary":"CXR7S","secondary":"eguAp","content":"WfxmY"};